export default "__VITE_ASSET__DMV_4P8D__"